// @ts-strict-ignore
import { context } from '../services';

/**
 * Return country code based on cookie
 */
export function getCountryCode(): string | undefined {
	return context.get('geo.country');
}

/**
 * Return continent code based on cookie
 */
export function getContinentCode(): string | undefined {
	return context.get('geo.continent');
}

/**
 * Return region code based on cookie
 */
export function getRegionCode(): string | undefined {
	return context.get('geo.region');
}

/**
 * Checks whether current country (from cookie) is listed in array
 */
export function isProperCountry(countryList: string[] = []): boolean {
	return !!(countryList && countryList.indexOf && countryList.indexOf(getCountryCode()) > -1);
}
